import {
    call, put, all, takeLatest, spawn, select,
} from 'redux-saga/effects';
import Api from '../services/ApiManager';
import notification from '../../helpers/notification';
import { deleteEntityAction, saveEntityAction } from '../actions/entityActions';
import { EntityActionTypes, saveEntityActionType, deleteEntityActionType } from '../../model/entity/action';
import { execSaveRequest, Options, execFillRequest } from './effects';
import { StatisticActionTypes, getDashboardStatisticActionType, getLiveStatisticActionType } from '../../model/statistic/actions';
import { getLiveStatisticAction, getDashboardStatisticAction } from '../actions/statisticActions';

function* getDashboardStatistic(action: StatisticActionTypes) {
    const botId = yield select(state => state.bot.selectedBot);
    if (botId !== undefined) {
        const options: Options = {
            payload: [botId, action.payload],
            hideErrorMessage: true
        };
        yield call(execFillRequest,
            Api.statistic.get,
            getDashboardStatisticAction.success,
            getDashboardStatisticAction.failure,
            options);
    }
}

function* getLiveStatistic(action: StatisticActionTypes) {
    const botId = yield select(state => state.bot.selectedBot);
    if (botId !== undefined) {
        const options: Options = {
            payload: [botId, action.payload],
        };
        yield call(execFillRequest,
            Api.statistic.getLive,
            getLiveStatisticAction.success,
            getLiveStatisticAction.failure,
            options);
    }
}

export function* startStatisticsSagas() {
    yield all([
        takeLatest(getDashboardStatisticActionType.request, getDashboardStatistic),
        takeLatest(getLiveStatisticActionType.request, getLiveStatistic),
    ]);
}